module.exports = __webpack_public_path__ + "img/fa-clipboard-user.607a18cc.svg";